module.exports = function() {
  return new Worker(__webpack_public_path__ + "af52b87bc1477eaa3515.worker.js");
};